import React from "react";

import { connect } from "react-redux";
import FormBox from "../../../presentational/page/formBox";
import MultiSelector from "../../../input/selectors/multiSelector";
import { yesNoStatus, labelStatus } from "../../../../constants/constants";
import CurrentlySelectedFiltersList from "../../../presentational/general/currentlySelectedFiltersList";
import Input from "../../../input/general/input";
import { editLabelTableParametersData } from "../../../../constants/tableParametersData/editLabelTableParametersData";
import DateRange from "../../../input/date/dateRange";
import Select from "../../../input/selectors/select";

const FiltersBox = () => {
  const filtersPath = editLabelTableParametersData.filtersPath;
  return (
    <FormBox title="Filters" style={{ zIndex: "999" }}>
      <div className="box-body">
        <table className="filters-table">
          <tbody>
            <tr>
              <td></td>
              <td></td>
              <td>
                <small className="label">Date added from-to</small>
              </td>
              <td>
                <small className="label">Date Updated from-to</small>
              </td>
              <td>
                <small className="label">Claimed</small>
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td style={{ width: "180px" }}>
                <div className="form-group">
                  <div className="input-group">
                    <Input placeholder="Search label..." className="form-control" name={`${filtersPath}.labelName`} />
                  </div>
                </div>
              </td>
              <td style={{ width: "100px" }}>
                <div className="form-group">
                  <MultiSelector
                    placeholder="Status"
                    data={labelStatus}
                    displayKey="name"
                    idKey="id"
                    autocomplete={true}
                    showClearButton={false}
                    name={`${filtersPath}.status`}
                  />
                </div>
              </td>
              <td>
                <div className="form-group">
                  <div className="input-group">
                    <DateRange name={`${filtersPath}.dateAdded`} />
                  </div>
                </div>
              </td>
              <td>
                <div className="form-group">
                  <div className="input-group">
                    <DateRange name={`${filtersPath}.lastChange`} />
                  </div>
                </div>
              </td>
              <td style={{ width: "120px" }}>
                <div className="form-group">
                  <Select idKey={"id"} displayKey="name" name={`${filtersPath}.claimed`} data={yesNoStatus} />
                </div>
              </td>
              <td style={{ width: "160px" }}>
                <div className="form-group">
                  <div className="input-group">
                    <Input
                      className="form-control"
                      placeholder={"Min beatport rank"}
                      type="number"
                      name={`${filtersPath}.beatportRank.min`}
                    />
                  </div>
                </div>
              </td>
              <td style={{ width: "160px" }}>
                <div className="form-group">
                  <div className="input-group">
                    <Input
                      className="form-control"
                      placeholder={"Max beatport rank"}
                      type="number"
                      name={`${filtersPath}.beatportRank.max`}
                    />
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div className="row">
          <div className="col-md-12">
            <CurrentlySelectedFiltersList
              tableParamsData={editLabelTableParametersData}
              connectedTo={editLabelTableParametersData.filtersPath}
            />
          </div>
        </div>
      </div>
    </FormBox>
  );
};

export default connect(null)(FiltersBox);
